import React from 'react';
import styled from 'styled-components';
import media from 'styled-media-query';

const ImageWrapper = styled.div`
    background-color:#F6F6F6;
    background-image: url('${process.env.PUBLIC_URL}/images/feedback-image.svg');
    background-position: center;
    background-repeat: no-repeat;
    height: 250px;
    width: 100%;

    ${media.lessThan('medium')`
		display: none;
	`}
`;

const DoubtFeedbackImage = () => (
    <ImageWrapper />
);

export default DoubtFeedbackImage;